import { CommonModule } from "@angular/common";
import { Component, computed, inject, signal } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { SettingService } from "@malirang/api-client";
import { BottomSheetComponent, BottomSheetItem } from "@malirang/app-share";
import { CONTENT } from "@malirang/common";
import { injectNavigationEnd } from "ngxtension/navigation-end";

@Component({
    selector: "app-footer",
    standalone: true,
    imports: [CommonModule, BottomSheetComponent],
    templateUrl: "./footer.component.html",
    styleUrl: "./footer.component.scss",
})
export default class FooterComponent {
    readonly router = inject(Router);
    private readonly settingService = inject(SettingService);
    isEnabled$ = rxResource({
        params: () => ({ key: "부모님검사도구사용여부" }),
        stream: ({ params }) =>
            this.settingService.settingControllerGet(params),
    });
    isEnabled = computed(
        () =>
            this.isEnabled$.value()?.value &&
            this.isEnabled$.value()?.value === "true",
    );

    showFooter = signal<boolean>(true);
    menus = computed<BottomSheetItem[]>(() =>
        // 네이티브 환경에서는 결제를 완전히 가립니다.
        Capacitor.isNativePlatform()
            ? [
                  {
                      title: "나의아동",
                      icon: "material-symbols-light:child-care",
                      url: "/my-child/dashboard",
                  },
                  {
                      title: "일정",
                      icon: "solar:calendar-search-bold-duotone",
                      url: "/schedule",
                  },
                  {
                      title: CONTENT,
                      icon: "solar:book-bookmark-bold-duotone",
                      url: "/content",
                  },
              ]
            : [
                  {
                      title: "나의아동",
                      icon: "material-symbols-light:child-care",
                      url: "/my-child/dashboard",
                  },
                  {
                      title: "일정",
                      icon: "solar:calendar-search-bold-duotone",
                      url: "/schedule",
                  },
                  {
                      title: "검사도구",
                      icon: "solar:ruler-pen-bold-duotone",
                      url: "/inspection",
                      disabled: !this.isEnabled(),
                  },
                  {
                      title: "스토어",
                      icon: "solar:home-2-bold-duotone",
                      url: "/store",
                  },
                  {
                      title: CONTENT,
                      icon: "solar:book-bookmark-bold-duotone",
                      url: "/content",
                  },
              ],
    );

    nonFooterList = ["/my-page/withdraw"];

    source$ = injectNavigationEnd();
    constructor() {
        // 새로고침 대응
        if (
            window?.location?.pathname &&
            this.nonFooterList.includes(window.location.pathname)
        ) {
            this.showFooter.set(false);
        } else {
            this.showFooter.set(true);
        }

        // 라우터 이동 대응
        this.source$.subscribe((event: NavigationEnd) => {
            if (event && event?.url && this.nonFooterList.includes(event.url)) {
                this.showFooter.set(false);
            } else {
                this.showFooter.set(true);
            }
        });
    }
}
